<template>
  <BaseDropdown
    v-model="showDropdown"
    :is-suffix-icon="isSuffixIcon"
  >
    <div
      class="user-menu"
      data-testid="talent-menu-label"
    >
      <ProfileAvatar
        v-if="!isMobile"
        class="user-avatar"
        :avatar="avatar"
      />

      <span
        v-else
        class="user-menu__burger"
      >
        menu
        <IconBurger />
      </span>
    </div>

    <template #dropdown>
      <div class="user-menu__header">
        {{ user?.name }}
        <ThemeSwitcher
          v-if="isMobile && showThemeSwitcher"
          :theme="theme"
          @switch-theme="switchTheme"
        />
      </div>

      <RouterLink
        class="user-menu-item"
        :to="localePath('/account')"
        data-testid="settings-btn"
      >
        <div class="prefix-icon">
          <IconSetting />
        </div>
        <div class="user-menu-item__label">
          {{ $t('account.settings') }}
        </div>
      </RouterLink>

      <div
        class="user-menu-item"
        data-testid="logout-btn"
        @click="logout"
      >
        <div class="prefix-icon">
          <IconExit />
        </div>
        <div class="user-menu-item__label">
          {{ $t('auth.logout') }}
        </div>
      </div>
    </template>
  </BaseDropdown>
</template>

<script>
import BaseDropdown from '@/components/common/BaseDropdown.vue'
import ProfileAvatar from '@/components/profile/ProfileAvatar.vue'
import { DeviceMixin } from '@/mixins/device.mixin.js'
import IconBurger from '@/components/icons/IconBurger.vue'
import IconSetting from '@/components/icons/IconSetting.vue'
import IconExit from '@/components/icons/IconExit.vue'
import { useAuthStore } from '@/store/auth.js'
import ThemeSwitcher from '@/components/theme/ThemeSwitcher.vue'

export default {
  name: 'TalentUserMenu',
  components: {
    ThemeSwitcher,
    IconBurger,
    IconSetting,
    BaseDropdown,
    IconExit,
    ProfileAvatar
  },
  mixins: [DeviceMixin],
  props: {
    theme: {
      type: [String, Object],
      default: null
    },
    isSuffixIcon: {
      type: Boolean,
      default: true
    },
    burgerInMobile: {
      type: Boolean,
      default: true
    },
    showThemeSwitcher: {
      type: Boolean,
      default: true
    }
  },
  emits: ['switchTheme'],
  data() {
    return {
      showDropdown: false,
      userStore: null,
      authStore: null
    }
  },
  computed: {
    user() {
      return this.authStore?.getUser
    },
    avatar() {
      return this.user?.avatar
    }
  },
  created() {
    this.authStore = useAuthStore()
  },
  methods: {
    hide() {
      this.showDropdown = false
    },
    logout() {
      this.hide()
      this.authStore.logout()
    },
    switchTheme(theme) {
      this.$emit('switchTheme', theme)
    }
  }
}
</script>

<style scoped lang="scss">
.user-menu {
  display: flex;
  align-items: center;
  column-gap: var(--space-12);

  .user-avatar {
    width: var(--space-48);
    height: var(--space-48);

    @include phone {
      width: var(--space-40);
      height: var(--space-40);
    }
  }

  .user-menu__burger {
    display: flex;
    align-items: center;
    color: var(--color-zinc-700);
    font-size: var(--font-size-body-2);
    line-height: var(--leading-170);
    font-weight: var(--weight-normal);
    gap: var(--space-8);
  }
}

.user-menu__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-zinc-400);
  padding: var(--space-20);
  font-size: var(--font-size-body-1);
  line-height: var(--leading-180);
  font-weight: var(--weight-normal);
  border-bottom: 1px solid var(--color-zinc-200);
  margin: 0;
}

.user-menu-item {
  display: flex;
  align-items: center;
  column-gap: var(--space-12);
  font-size: var(--font-size-body-1);
  line-height: var(--leading-180);
  font-weight: var(--weight-normal);
  color: var(--color-zinc-700);
  padding: var(--space-12) var(--space-16);
  cursor: pointer;
  text-decoration: none;

  .prefix-icon {
    display: flex;
    justify-content: center;
    width: 1.8rem;
    height: 1.8rem;
    color: var(--color-brand-500);

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &:hover {
    background: var(--color-zinc-50);
  }
}
</style>
